module.exports = __webpack_public_path__ + "img/stas-main_768.7616926c.webp";